// extracted by mini-css-extract-plugin
module.exports = {"xs_only":"only screen and (max-width: 767px)","font_size_small":"next_step_button__font_size_small__6q8qb","margin_bottom_xxlarge":"next_step_button__margin_bottom_xxlarge__Md8gn"};